import React from 'react'
import { ColumnMappingString } from 'api'
import { ColumnMappingPanelProps, ColumnMappingPanel } from './ColumnMappingPanel'
import { ColumnMappingHeaderSelectbox } from './ColumnMappingHeaderSelectbox'

export const ColumnMappingStringPanel: React.FunctionComponent<ColumnMappingPanelProps<ColumnMappingString>> = props => {
  const { fieldTitle, fieldName, columnMapping, parseResult, onUpdate } = props

  return (
    <ColumnMappingPanel>
      <ColumnMappingHeaderSelectbox
        fieldTitle={fieldTitle}
        fieldName={fieldName}
        columnMapping={columnMapping}
        parseResult={parseResult}
        onUpdate={onUpdate}
      />
    </ColumnMappingPanel>
  )
}
